import React from "react";
import WeatherIcons from "./WeatherIcons";

export default function ForecastDay(props) {
  function day() {
    let date = new Date(props.data.dt * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[day];
  }
  return (
    <div className="Forecastday">
      <div className="card-body">
        <h6 className="card-title">{day()}</h6>
        <hr />
        <WeatherIcons code={props.data.weather[0].icon} size={32} />
      </div>
      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          Day: {Math.round(props.data.temp.day)}°C
        </li>
        <li className="list-group-item">
          Night: {Math.round(props.data.temp.night)}°C
        </li>
      </ul>
    </div>
  );
}
